import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyomuinKyuyoMasterGetRes,
  TZyomuinKyuyoMasterListGetReq,
  TZyomuinKyuyoMasterListGetRes,
  TZyomuinKyuyoMasterRegisterPostReq,
  TZyomuinKyuyoMasterRegisterPutReq,
} from "./TZyomuinKyuyoMaster"

/**
 * 乗務員給与マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class ZyomuinKyuyoMasterService
 * @extends {ConnectApi}
 */
export default class ZyomuinKyuyoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZyomuinKyuyoMasterListGetReq} params
   * @memberof ZyomuinKyuyoMasterService
   */
  getList = async (
    params: TZyomuinKyuyoMasterListGetReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinKyuyoMasterListGetRes>> =
        await this.getInner(`/driverpayroll/zyomuinkyuyomaster`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinKyuyoMasterGetRes>> =
        await this.getInner(`/driverpayroll/zyomuinkyuyomaster/${id}`, signal)
      return res.data

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TZyomuinKyuyoMasterRegisterPutReq} data
   * @param {(param: TApiResponse<TZyomuinKyuyoMasterGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZyomuinKyuyoMasterGetRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (
    id: number,
    data: TZyomuinKyuyoMasterRegisterPutReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zyomuinkyuyomaster/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 新規登録
   *
   * @param {TZyomuinKyuyoMasterRegisterPostReq} data
   * @memberof KyotenService
   */
  post = async (
    id: number,
    data: TZyomuinKyuyoMasterRegisterPostReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/driverpayroll/zyomuinkyuyomaster/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
